/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S4_Item2_LabelInputs */

const tr_cerez_s4_item2_label = /** @type {(inputs: Cerez_S4_Item2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalıcı çerezler:`)
};

const en_cerez_s4_item2_label = /** @type {(inputs: Cerez_S4_Item2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Persistent cookies:`)
};

const de_cerez_s4_item2_label = /** @type {(inputs: Cerez_S4_Item2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dauerhafte Cookies:`)
};

const ru_cerez_s4_item2_label = /** @type {(inputs: Cerez_S4_Item2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Постоянные файлы cookie:`)
};

/**
* | output |
* | --- |
* | "Persistent cookies:" |
*
* @param {Cerez_S4_Item2_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s4_item2_label = /** @type {((inputs?: Cerez_S4_Item2_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S4_Item2_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s4_item2_label(inputs)
	if (locale === "de") return de_cerez_s4_item2_label(inputs)
	if (locale === "ru") return ru_cerez_s4_item2_label(inputs)
	return tr_cerez_s4_item2_label(inputs)
});